import React, { forwardRef } from 'react';
import { TextElement } from '@basis-theory/react-elements';
import { useTheme } from '@material-ui/core/styles';

import { styles } from './text.styles';

const BasisTheoryText = forwardRef(function BasisTheoryText(props, ref) {
  const { mode } = props;
  const theme = useTheme();
  const inlineStyles = styles(theme);

  return (
    <TextElement
      {...props}
      ref={ref}
      style={mode === 'dark' ? inlineStyles.textElementStyleDark : inlineStyles.textElementStyleLight}
    />
  );
});

export default BasisTheoryText;
